<template>
  <div class="auth-page">
    <div class="container-fluid p-0">
      <div class="row g-0 align-items-center justify-content-center">
        <div class="col-xxl-6 col-lg-6 col-md-6">
          <div class="row justify-content-center g-0">
            <div class="col-xl-9">
              <div class="p-4">
                <div class="card mb-0">
                  <div class="card-body">
                    <div class="auth-full-page-content rounded d-flex p-3 my-2">
                      <div class="w-100">
                        <div class="d-flex flex-column h-100">
                          <div class="auth-content my-auto">
                            <div class="text-center">
                              <h5 class="mb-0">{{ $t('SYSA - Afiliados') }}</h5>
                            </div>
                            <form v-if="!secondStep" class="mt-4 pt-2" @submit.prevent="onSubmit">
                              <div class="form-floating form-floating-custom mb-4">
                                <input
                                  type="text"
                                  class="form-control"
                                  id="input-username"
                                  v-model="email"
                                  placeholder="E-mail"
                                />
                                <label for="input-username">E-mail</label>
                                <div class="form-floating-icon">
                                  <eva-icon name="people-outline"></eva-icon>
                                </div>
                              </div>

                              <div class="form-floating form-floating-custom mb-4 auth-pass-inputgroup">
                                <input
                                  :type="showPassword ? 'text' : 'password'"
                                  class="form-control pe-5"
                                  id="password-input"
                                  v-model="password"
                                  :placeholder="$t('Password')"
                                />

                                <button
                                  type="button"
                                  class="btn btn-link position-absolute h-100 end-0 top-0"
                                  id="password-addon"
                                  @click="tooglePasswordVisible"
                                >
                                  <i class="mdi mdi-eye-outline font-size-18 text-muted"></i>
                                </button>
                                <label for="password-input">{{ $t('Password') }}</label>
                                <div class="form-floating-icon">
                                  <eva-icon name="lock-outline"></eva-icon>
                                </div>
                              </div>

                              <div class="mb-3">
                                <button
                                  class="btn btn-primary w-100 waves-effect waves-light"
                                  type="submit"
                                  :disabled="$store.state.isLoading"
                                >
                                  <i v-if="$store.state.isLoading" class="fas fa-circle-notch sysa-spinner"></i>
                                  <span v-else>Login</span>
                                </button>
                              </div>
                            </form>
                            <form v-else class="mt-4 pt-2" @submit.prevent="onSubmitOtp">
                              <label>{{ $t('Two step verification code') }}</label>
                              <div class="form-floating form-floating-custom mb-4">
                                <input
                                  class="totp-pass-input form-control pt-2"
                                  type="text"
                                  v-model="otpCode"
                                  required="required"
                                />
                              </div>

                              <div class="mb-3">
                                <button
                                  class="btn btn-primary w-100 waves-effect waves-light"
                                  type="submit"
                                  :disabled="$store.state.isLoading"
                                >
                                  <i v-if="$store.state.isLoading" class="fas fa-circle-notch sysa-spinner"></i>
                                  <span v-else>Login</span>
                                </button>
                              </div>
                            </form>
                          </div>
                          <div class="mt-4 text-center">
                            <p class="mb-0">© {{ year }} {{ domain }}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal v-model="showQRCode" title="QR Code" ok-only @ok="showSecondStepForm">
      <template #default>
        <div class="d-flex flex-column align-items-center">
          <registerOtpAuth :otpLink="otpLink" />
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import registerOtpAuth from './registerOtpAuth.vue';
export default {
  components: {
    registerOtpAuth
  },
  data() {
    return {
      email: '',
      password: '',
      otpCode: '',
      domain: window.location.hostname,
      showPassword: false,
      year: new Date().getFullYear(),
      showQRCode: false,
      otpData: null,
      secondStep: false
    };
  },
  computed: {
    otpLink() {
      return this.otpData?.otpLink || '';
    }
  },
  methods: {
    onSubmit() {
      if (!this.email || !this.password) {
        this.$customAlert({
          type: 'error',
          msg: this.$t('Provide access credentials')
        });
        return;
      }

      this.$store.commit('SET_LOADING', true);

      this.$auth
        .login({
          email: this.email,
          password: this.password
        })
        .then((res) => {
          this.$store.commit('SET_LOADING', false);

          if (res?.data?.codResposta == '209') {
            this.otpData = res.data;
            this.showQRCode = true;
            return;
          }

          if (res?.data?.codResposta == '210') {
            this.otpData = res.data;
            this.showSecondStepForm();
            return;
          }

          this.$customAlert({
            type: 'success',
            msg: 'Login with success'
          });
          this.$router.push({ name: 'home' });
        })
        .catch((err) => {
          this.$store.commit('SET_LOADING', false);
          this.$customAlert({
            type: 'error',
            msg: err?.response?.data?.message || this.$t('Authentication error')
          });
        });
    },
    onSubmitOtp() {
      const body = {
        totp: this.otpCode,
        accessToken: this.otpData.accessToken
      };

      this.$store.commit('SET_LOADING', true);

      this.$auth
        .secondStepLogin(body)
        .then(() => {
          this.$store.commit('SET_LOADING', false);
          this.$customAlert({
            type: 'success',
            msg: 'Login with success'
          });
          this.$router.push({ name: 'home' });
        })
        .catch((err) => {
          console.log(err);
          this.$store.commit('SET_LOADING', false);
          this.$customAlert({
            type: 'error',
            msg: err?.response?.data?.message || this.$t('Authentication error')
          });
        });
    },
    showSecondStepForm() {
      this.secondStep = true;
      this.showQRCode = false;
    },
    tooglePasswordVisible() {
      this.showPassword = !this.showPassword;
    }
  }
};
</script>

<style lang="scss" scoped>
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type='number'] {
  -moz-appearance: textfield;
}

.totp-pass-input {
  letter-spacing: 15px;
  text-align: center;
  font-size: 30px;
}
</style>
